import React, { useState } from 'react';

export default function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted:", formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-lg border">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Contact Us</h1>
        <p className="text-center text-gray-600 mb-8">We'd love to hear from you. Send us a message below.</p>
        {submitted ? (
          <div className="text-center p-4 bg-green-100 text-green-800 rounded-lg">
            Thank you for your message! We will get back to you shortly.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="contact-name" className="block text-gray-700 font-semibold mb-2">Full Name</label>
              <input type="text" id="contact-name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required />
            </div>
            <div className="mb-4">
              <label htmlFor="contact-email" className="block text-gray-700 font-semibold mb-2">Email Address</label>
              <input type="email" id="contact-email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required />
            </div>
            <div className="mb-6">
              <label htmlFor="contact-message" className="block text-gray-700 font-semibold mb-2">Message</label>
              <textarea id="contact-message" rows="5" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" required></textarea>
            </div>
            <button type="submit" className="w-full bg-green-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-green-700 transition-colors">Send Message</button>
          </form>
        )}
      </div>
    </div>
  );
}


